class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    // Always close the actual cart drawer as well as any legacy subscription
    // modal state. The old early return could leave the drawer overlay active,
    // which is why the page stayed dark after closing the cart on mobile.
    this.closeModal();
    this.classList.remove('active', 'animate');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  closeModal() {
    // Hide modal
    this.classList.remove('subscription-modal--opened')
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState, is_onetime = false) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    if (is_onetime) {
      this.itemData = {
        variant_id: parsedState.variant_id,
        key: parsedState.key,
        quantity: parsedState.quantity,
        sku: parsedState.sku,
        url: parsedState.url
      }
    } else {
      this.itemData = null
    }
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();

      if (is_onetime) {
        // The legacy subscription modal is currently disabled
        // (showOnetimeModal is not called), so do not leave its overlay class
        // active behind the cart drawer.
        this.classList.remove('subscription-modal--opened');

        // this.showOnetimeModal(parsedState.variant_id);
      }
    });
  }

  switchOneTime() {
    if (this.itemData == null) {
      this.closeModal();

      return;
    }

    const selling_plans = [
      {
        // Variety Pack
        id: 43456416514304,
        plan: 3246227712
      },
      { 
        // Sticky Cinnamon
        id: 43445940060416,
        plan: 3242656000
      },
      {
        // Summer Strawberry
        id: 43445899165952,
        plan: 3242623232
      },
      {
        // Hot Chocolate
        id: 43445699346688,
        plan: 3242688768
      }
    ]

    const variantId = this.itemData.variant_id

    const selected_plan = selling_plans.find(item => item.id == variantId )

    // Generate Cart Data
    const changeConfig = fetchConfig('javascript');
    changeConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete changeConfig.headers['Content-Type'];

    const changeFormData = new FormData();
    changeFormData.append('id', this.itemData.key);
    changeFormData.append('quantity', 0);
    this.setActiveElement(document.activeElement);
    changeConfig.body = changeFormData;

    fetch(`${routes.cart_change_url}`, changeConfig)
    .then((res) => res.json())
    .then((res) => {
      if (res.status) {
        return;
      }
      
      const addConfig = fetchConfig('javascript');
      addConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete addConfig.headers['Content-Type'];
      const addFormData = new FormData();
      addFormData.append('sections', this.getSectionsToRender().map((section) => section.id));
      addFormData.append('sections_url', window.location.pathname);
      addFormData.append('id', variantId);
      addFormData.append('selling_plan', selected_plan.plan);
      addFormData.append('quantity', this.itemData.quantity);
      this.setActiveElement(document.activeElement);
      addConfig.body = addFormData;

      fetch(`${routes.cart_add_url}`, addConfig)
      .then((addResponse) => addResponse.json())
      .then((addResponse) => {
        if (addResponse.status) {
          return;
        }
  
        this.renderContents(addResponse);
      })
      .catch((ae) => {
        console.error(ae);
      })
      .finally(() => {
        this.closeModal();
  
        // this.submitButton.classList.remove('loading');
        if (this.classList.contains('is-empty')) this.classList.remove('is-empty');
      });
    })
    .catch((e) => {
      console.error(e);
    })

  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
